/* global Dropzone, Handlebars */

(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/csv', {
      templateUrl: 'modules/app/data/csv/csv.html',
      controller: 'CsvCtrl',
      requiredPermissions: ['admin']
    }).when('/data/csv/:tab/:templateId?', {
      templateUrl: 'modules/app/data/csv/csv.html',
      controller: 'CsvCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('CsvCtrl', ['$location', '$route', '$routeParams', '$scope', function ($location, $route, $routeParams, $scope) {
    $scope.section = "csv";
    if ($routeParams.tab) {
      $scope.activeTab = $routeParams.tab;
    }

    // if templateId provided on path, must be editing a template
    if ($routeParams.templateId) {
      $scope.editTemplate = true;
    }
    $scope.selectTab = function selectTab(tabId) {
      if ($routeParams.tab !== undefined && tabId !== $routeParams.tab) {
        $route.updateParams({
          'tab': tabId
        });
      }
    };
  }]).service('CsvTemplatesSvc', ['$http', '$q', '$rootScope', 'Api', function ($http, $q, $rootScope, Api) {
    $rootScope.$on('organization-selected', function () {
      self._templates = null;
    });
    var self = {
      _templates: null,
      get: function get() {
        if (self._templates === null) {
          //get the list of templates
          return $http.get(Api.url("import-template")).then(function (r) {
            self._templates = r.data.results;
            //get the import counts for each template
            return $http.get(Api.url("statement-import/count"), {
              params: {
                templates: self._templates.map(function (template) {
                  return template.name;
                })
              }
            }).then(function (r) {
              r.data.forEach(function (d) {
                var template = self._templates.find(function (t) {
                  return t.name.toLowerCase() === d[0].toLowerCase();
                });
                if (template) {
                  template.importCount = d[1];
                }
              });
              return self._templates;
            });
          });
        } else {
          var def = $q.defer();
          def.resolve(self._templates);
          return def.promise;
        }
      },
      update: function update() {
        self._templates = null;
        return self.get();
      }
    };
    return self;
  }]).service('HandlebarsHelpersSvc', ['$http', '$q', 'Api', function ($http, $q, Api) {
    var self = {
      _helpers: null,
      get: function get() {
        if (self._helpers === null) {
          //get the list of helpers
          return $http.get(Api.url("import-template/helpers")).then(function (r) {
            self._helpers = r.data;
            return self._helpers;
          });
        } else {
          var def = $q.defer();
          def.resolve(self._helpers);
          return def.promise;
        }
      }
    };
    return self;
  }]).controller('ImportCsvCtrl', ['$filter', '$http', '$scope', '$timeout', '$uibModal', '$q', 'Alerts', 'Api', 'ConfirmModal', 'Logger', 'OrganizationSettings', 'User', 'UserRoles', 'Upload', 'wsEventNames', 'xsrf', 'Utils', '$sanitize', function ($filter, $http, $scope, $timeout, $uibModal, $q, Alerts, Api, ConfirmModal, Logger, OrganizationSettings, User, UserRoles, Upload, wsEventNames, xsrf, Utils, $sanitize) {
    $scope.template = null;
    $scope.view = {
      loadingImports: true
    };
    $scope.groupActionOptions = [{
      'name': 'Create/Update',
      'value': 'create_update'
    }, {
      'name': 'Create/Replace',
      'value': 'create_replace'
    }, {
      'name': 'Add Memberships',
      'value': 'add_memberships'
    }, {
      'name': 'Delete',
      'value': 'delete'
    }
    // Not exposing replace_memberships or remove_memberships until deemed useful
    ];
    $scope.groupAction = $scope.groupActionOptions[0];
    $scope.templates = [{
      name: 'Default Interaction Statements Template',
      id: 'DEFAULT'
    }, {
      name: 'Default Group Import Template',
      id: 'DEFAULT_GROUPS'
    }];
    var user = User.get(),
      orgId = user.organization && user.organization.id;
    $scope.isSystemAdmin = UserRoles.isSystemAdmin(user);
    OrganizationSettings.getForOrganization(orgId).then(function (settings) {
      // If essentials, drop the default group template from the list
      if (settings.pricingTier === "ESSENTIALS") {
        $scope.templates = _.filter($scope.templates, function (t) {
          return t.id !== 'DEFAULT_GROUPS';
        });
      }
    });
    $scope.getTemplateName = function getTemplateName(template) {
      var defaultTemplate = _.find($scope.templates, function (t) {
        return t.id === template;
      });
      return defaultTemplate ? defaultTemplate.name : template;
    };
    $scope.imports = [];

    // todo: implement sorting by columns
    // fetch import history data
    $scope.fetchPage = function (offset, limit) {
      return $http.get(Api.url("statement-import/search"), {
        params: {
          'search_term': $sanitize($scope.searchTerm),
          'order_by': '-created',
          '_offset': offset,
          '_limit': limit,
          'sparse': true
        }
      }).then(function (r) {
        // Augment the data
        _.each(r.data.results, function (i) {
          i.elapsedTime = moment.duration(moment.utc(i.updated).diff(moment.utc(i.created))).format("h [hrs], m [min]");
        });
        $scope.view.loadingImports = false;
        return r.data;
      });
    };
    var prevSearchTerm = '';
    $scope.updateSearchTerm = function updateSearchTerm() {
      if ($scope.searchTerm !== prevSearchTerm) {
        prevSearchTerm = $scope.searchTerm;
        resetPager();
      }
    };
    var resetPager = function resetPager() {
      return $timeout(function () {
        // pass in the first page to reset the pager
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
      }, 500);
    };
    var refreshPage = function refreshPage() {
      return $timeout(function () {
        // use the "no param" option to refresh page without resetting it
        $scope.$broadcast(wsEventNames.pager.setPage);
      }, 500);
    };
    refreshPage();

    //get all the templates available
    $http.get(Api.url("import-template")).then(function (r) {
      $scope.templates.push.apply($scope.templates, r.data.results);
    });
    $scope.getSourceUrl = function (imp) {
      return Api.url("/statement-import/" + imp.id + "/source");
    };
    $scope.downloadSource = function (imp) {
      window.open($scope.getSourceUrl(imp), '_self');
    };
    $scope.exampleCsvUrl = Api.url("/statement-import/example");
    $scope.exampleGroupCsvUrl = Api.url("/group-import/example");
    var statementPipeUrl = Api.url("/statement-pipes");
    $http.get(statementPipeUrl).then(function fetchStatementPipesSuccess(response) {
      var hasOutboundStatementPipes = false;
      if (response.data.results.length > 0) {
        var outboundPipes = _.filter(response.data.results, function (pipe) {
          return pipe.sourceUrl.indexOf("/organizations/" + pipe.organization.id + "/") > 0;
        });
        hasOutboundStatementPipes = outboundPipes.length > 0;
      }
      if (!hasOutboundStatementPipes) {
        $scope.hideVoid = true;
      }
    });
    var getImportDescription = function getImportDescription(imp) {
      return "of " + imp.file + " using template " + $scope.getTemplateName(imp.template) + " by " + imp.userName + " on " + $filter('date')(imp.created);
    };
    var getImportDetail = function getImportDetail(imp) {
      var details = "<ul>";
      if (imp.personCount > 0) {
        details += "<li>" + imp.personCount + (imp.personCount === 1 ? " Person" : " People") + "</li>";
      }
      if (imp.groupCount > 0) {
        details += "<li>" + imp.groupCount + " Group" + (imp.groupCount === 1 ? "" : "s") + "</li>";
      }
      if (imp.groupTypeCount > 0) {
        details += "<li>" + imp.groupTypeCount + " Group type" + (imp.groupTypeCount === 1 ? "" : "s") + "</li>";
      }
      if (imp.permissionCount > 0) {
        details += "<li>" + imp.permissionCount + " Permission" + (imp.permissionCount === 1 ? "" : "s") + "</li>";
      }
      if (imp.statementCount > 0) {
        details += "<li>" + imp.statementCount + " Interaction" + (imp.statementCount === 1 ? "" : "s") + "</li>";
      }
      return details + "</ul>";
    };
    $scope.voidImport = function (imp) {
      var impDesc = getImportDescription(imp),
        impDetail = getImportDetail(imp);
      ConfirmModal.open($scope, {
        title: "Void import",
        body: "This action will void the import " + impDesc + "." + (impDetail ? "  The following items will be voided:<br>" + impDetail : "") + "<br>Are you sure you want to void this import?",
        confirmBtn: "Yes void this import",
        confirm: function confirm() {
          $http.delete(Api.url("statement-import/" + imp.id + "?deleteLrsStatements=false")).then(function () {
            Alerts.raiseAlert({
              type: "info",
              text: "The import " + impDesc + " has been voided."
            });
            refreshPage();
          });
          imp.voiding = true;
        }
      });
    };
    $scope.deleteImport = function (imp) {
      var impDesc = getImportDescription(imp),
        impDetail = getImportDetail(imp);
      ConfirmModal.open($scope, {
        title: "Delete import",
        body: "This action will delete the import " + impDesc + "." + (impDetail ? "  The following items will be deleted:<br>" + impDetail : "") + "<br>Are you sure you want to delete this import?",
        confirmBtn: "Yes delete this import",
        confirm: function confirm() {
          $http.get(Api.url('statement-import/job-in-progress')).then(function (r) {
            var importRunning = r.data !== null && r.data.length > 0;
            $http.delete(Api.url("statement-import/" + imp.id + "?deleteLrsStatements=true")).then(function (result) {
              if (!importRunning) {
                $scope.deleting = true;
                $scope.jobInProgress.id = result.data;
                reportJobProgress();
              }
            });
            imp.deleting = true;
          });
        }
      });
    };
    $scope.abortImport = function (job) {
      $http.post(Api.url("statement-import/job/" + job.id + "/abort")).then(function () {
        Alerts.raiseAlert({
          type: "info",
          text: "Import aborting..."
        });
        refreshPage();
      });
    };
    var previewFiles = [];
    $scope.jobInProgress = {
      completed: 0,
      id: 0
    };
    var clearPreviewState = function resetImportState() {
      $scope.importing = false;
      $scope.showPreview = false;
      $scope.doPreviewStep = true;
      $scope.doValidateStep = true;
      $scope.doSyncStep = true;
      $scope.previewStatementCount = 0;
      $scope.previewStatements = [];
      $scope.failedRows = [];
      $scope.rowWarnings = [];
      $scope.details = [];
      previewFiles = [];
    };
    clearPreviewState();
    $scope.error = null;
    var progressInterval = 3000,
      progressPromise; //Pointer to the promise created by the Angular $timout service

    function reportJobProgress() {
      $http.get(Api.url('statement-import/job/' + $scope.jobInProgress.id)).then(function (r) {
        var job = r.data;
        $scope.jobInProgress = job;
        if ($scope.jobInProgress.percentage === 0) {
          $scope.jobInProgress.percentage = 0.01; // Give something here so the progress bar is exposed
        }
        if (job.status === "completed" || job.status === "aborted" || job.status === "paused") {
          $timeout(function () {
            $scope.jobInProgress = {
              completed: 0,
              id: 0
            };
          }, 1000);
          clearPreviewState();
          refreshPage();
          Alerts.refreshAlerts();
          $timeout(initJobProgress, progressInterval);
        } else {
          progressPromise = $timeout(reportJobProgress, progressInterval);
        }
      }, function (err) {
        Logger.warn(err);
        $scope.jobInProgress = {
          completed: 0,
          id: 0
        };
      });
    }

    // When we navigate away, be sure to kill the progress polling...
    $scope.$on('$destroy', function () {
      $timeout.cancel(progressPromise);
    });
    function initJobProgress() {
      // If returning to the page, get the current job in progress

      if ($scope.jobInProgress && $scope.jobInProgress.id && $scope.jobInProgress.id > 0) {
        return;
      }
      $http.get(Api.url('statement-import/job-in-progress')).then(function (r) {
        if (r.data !== null && (r.data.currentStep || r.data.length > 0)) {
          $scope.jobInProgress = {};
          $scope.jobInProgress.id = r.data.jobId;
          if (r.data.status !== "aborted") {
            progressPromise = $timeout(reportJobProgress, 10);
          }
        }
      });
    }
    initJobProgress();
    var upload = null;
    $scope.import = function () {
      if ($scope.uploading) {
        return;
      }
      $scope.importing = true;
      $scope.uploading = true;
      $scope.deleting = false;
      $scope.error = null;
      $scope.showDropzone = false;
      $scope.showPreview = false;
      var onSuccess = function onSuccess(result) {
        if (!$scope.jobInProgress.id) {
          $scope.jobInProgress.id = result.data;
          reportJobProgress();
        }
        $scope.$safeApply(function () {
          Utils._try(function () {
            return Alerts.raiseAlert({
              type: "info",
              text: "The import has been started using the " + $scope.template.name + " import template. Please note that it could take up to an hour " + "to fully process every interaction statement."
            });
          });
          refreshPage();
          clearPreviewState();
        });
        $scope.template = null;
        $scope.uploading = false;
      };
      var onError = function onError(e) {
        $scope.importing = false;
        $scope.error = 'No further detail available.';
        if (e.status > 0) {
          $scope.error = e.data && e.data.message;
        }
        $scope.uploading = false;
      };
      var onProgress = function onProgress(e) {
        $scope.uploadPercentage = parseInt(100.0 * e.loaded / e.total);
      };
      for (var i = 0; i < previewFiles.length; i++) {
        var file = previewFiles[i];
        var url = Api.url('statement-import?template=' + (["DEFAULT", "DEFAULT_GROUPS"].indexOf($scope.template.id) > -1 ? $scope.template.id : encodeURIComponent($scope.template.name)) + "&groupAction=" + $scope.groupAction.value + "&skipValidation=" + !$scope.doValidateStep + "&skipSync=" + !$scope.doSyncStep + "&fileSize=" + file.size);
        upload = Upload.upload({
          url: url,
          file: file
        });
        upload.then(onSuccess, onError, onProgress);
      }
      previewFiles = [];
    };
    $scope.abortUpload = function abortUpload() {
      if (upload) {
        upload.abort();
        Alerts.raiseAlert({
          type: "info",
          text: "Upload aborted."
        });
        $scope.cancel();
      }
    };
    $scope.cancel = function () {
      clearPreviewState();
    };
    $scope.formatProgressMessage = function (jobInProgress) {
      switch (jobInProgress.messages) {
        case "SUBMITTED":
          return "Submitted CSV file for import...";
        case "INITIALIZING":
          return "Initializing import process...";
        case "VALIDATING":
          return "Validated " + jobInProgress.completed + " of " + jobInProgress.total + " rows";
        case "IMPORTING":
          return "Processed " + jobInProgress.completed + " of " + jobInProgress.total + " rows";
        case "UPDATE_PERMISSIONS":
          return "Processed " + jobInProgress.completed + " of " + jobInProgress.total + " permissions";
        case "UPDATE_GROUPS":
          return "Processed " + jobInProgress.completed + " of " + jobInProgress.total + " group updates";
        case "UPDATE_MEMBERSHIPS":
          return "Updated " + jobInProgress.completed + " of " + jobInProgress.total + " group memberships";
        case "SYNCHRONIZING":
          return "Synchronizing reporting data...";
        case "COMPLETED":
          return "Import Completed";
        case "DELETE_SUBMITTED":
          return "Submitted delete request...";
        case "DELETING":
          return "Deleting CSV Import";
        case "DELETED":
          return "Import Deleted";
        default:
          return jobInProgress.messages;
      }
    };
    $scope.findAndShowDetails = function (importId, detailType) {
      var imp, header, detailRef;
      if (detailType === 'error') {
        header = 'Errors';
        detailRef = 'failedRows';
      }
      if (detailType === 'warning') {
        header = 'Warnings';
        detailRef = 'rowWarnings';
      }
      $http.get(Api.url("statement-import/" + importId)).then(function (_ref) {
        var data = _ref.data;
        return imp = data;
      }).then(function (imp) {
        return $scope.showDetails(imp[detailRef], header);
      });
    };
    $scope.showDetails = function (details, header) {
      if (!_.isArray(details)) {
        details = _.map(details, function (v, k) {
          return {
            row: k,
            detail: v
          };
        });
      }
      $scope.details = details;
      $scope.showFilename = details.findIndex(function (x) {
        return x.file && x.file !== '';
      }) >= 0;
      $scope.header = header;
      $scope.showErrorsModal = $uibModal.open({
        templateUrl: 'modules/app/data/csv/row-details-modal.html',
        controller: 'RowDetailModalCtrl',
        backdrop: 'static',
        scope: $scope,
        size: 'lg'
      });
    };
    $scope.showRawTemplateResults = function () {
      $scope.rawTemplateResultsModal = $uibModal.open({
        templateUrl: 'modules/app/data/csv/template-results-modal.html',
        controller: 'TemplateResultsModalCtrl',
        backdrop: 'static',
        scope: $scope,
        size: 'lg'
      });
    };
    $scope.size = _.size;
    $scope.createDataImportDropzone = function createDataImportDropzone() {
      // Only define once
      if ($scope.dataImportDropzone) {
        return;
      }
      $scope.dataImportDropzone = new Dropzone("#data-import-dropzone", {
        url: function url() {
          return Api.url('statement-import/preview?template=' + $scope.template.id);
        },
        method: "post",
        enctype: "multipart/form-data",
        headers: xsrf.getHeaders(),
        addRemoveLinks: true,
        acceptedFiles: '.txt,.csv',
        dictInvalidFileType: "Files of this type are not accepted. Please select a csv file.",
        accept: function accept(file, done) {
          $scope.$safeApply(function () {
            $scope.dropzoneErrorMessage = null;
          });
          if (!$scope.template) {
            done('Please select a template.');
          } else {
            done();
          }
          if (!$scope.doPreviewStep) {
            previewFiles.push(file);
            $scope.dataImportDropzone.removeFile(file);
            $timeout(function () {
              $scope.import();
            });
          }
        },
        uploadprogress: function uploadprogress(file, progress) {
          $(file.previewElement).find('.dz-upload')[0].style.width = progress + '%';
          if (progress === 100) {
            $(file.previewElement).find('.dz-progress').remove();
            $(file.previewElement).find('.dz-size').append('<img src=img/loading/loading.gif" alt="Processing"><p>Processing...</p>');
          }
        },
        error: function error(file, e) {
          $scope.$safeApply(function () {
            $scope.dropzoneErrorMessage = "Import failed: " + (e.exceptionMessage || e);
          });
          $scope.dataImportDropzone.removeFile(file);
        },
        complete: function complete(file) {
          if (file.status === "error") {
            //simple attempt at error display, only gets called on exceptions?
            try {
              $(file.previewElement).find('.dz-error-message').text(JSON.parse(file.xhr.response).exceptionMessage);
            } catch (e) {
              //ignore
            }
            return;
          }
          previewFiles.push(file);
          $scope.dataImportDropzone.removeFile(file);
          var r = JSON.parse(file.xhr.response);
          var fileName = file.name;
          $scope.$safeApply(function () {
            $scope.rowCount = r.rowCount;
            $scope.isAborted = r.isAborted;
            var stmts = _.flatten(_.values(r.formattedStatements));
            $scope.previewStatementCount += stmts.length;
            $scope.previewItemCount += stmts.length;
            for (var i = 0; i < stmts.length && $scope.previewStatements.length < 5; i++) {
              $scope.previewStatements.push(stmts[i]);
            }
            $scope.failedRows.push.apply($scope.failedRows, _.map(r.failedRows, function (v, k) {
              return {
                row: k,
                detail: v,
                file: fileName
              };
            }));
            $scope.rowWarnings.push.apply($scope.rowWarnings, _.map(r.rowWarnings, function (v, k) {
              return {
                row: k,
                detail: v
              };
            }));
            $scope.previewGroups = _.flatten(_.values(r.groups));
            $scope.previewItemCount += $scope.previewGroups.length;
            $scope.previewPeople = _.flatten(_.values(r.people));
            $scope.previewItemCount += $scope.previewPeople.length;
            $scope.previewPermissions = _.flatten(_.values(r.permissions));
            $scope.previewItemCount += $scope.previewPermissions.length;
            $scope.previewRaw = _.map(r.templateResultByRow, function (v, k) {
              return {
                rowNum: k,
                generatedObjects: v
              };
            });
            $scope.previewFilename = file.name;
            $scope.showPreview = true;
          });
        },
        maxFilesize: 2048 // MB
      });
      $scope.dataImportDropzone.on("sending", function (file, xhr, formData) {
        formData.append("filesize", file.size);
      });
    };
    $scope.importLock = false;
    $scope.importLockLoading = false;
    $scope.refreshImportLock = function () {
      $scope.importLockLoading = true;
      var params = {
        tenantId: orgId
      };
      $http.get(Api.url('/cache/import-lock', true), {
        params: params
      }).then(function (r) {
        var data = r.data;
        $scope.importLock = data.importLock !== undefined;
        $scope.importLockLoading = false;
        if ($scope.importLock) {
          $scope.importLockData = JSON.stringify(JSON.parse(data.importLock), null, 2);
        }
      });
    };
    $scope.freeImportLock = function () {
      $scope.importLockLoading = true;
      var params = {
        tenantId: orgId
      };
      $http.delete(Api.url('/cache/import-lock', true), {
        params: params
      }).then(function () {
        $scope.importLock = false;
        $scope.importLockLoading = false;
      });
    };
    $scope.refreshImportLock();
    $scope.showDropzone = false;
  }]).controller('RowDetailModalCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    $scope.page = [];
    $scope.pageCallback = function (page) {
      $scope.page = page;
    };
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
  }]).controller('TemplateResultsModalCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    $scope.templateResultsPage = [];
    $scope.templateResultsPageCallback = function (page) {
      $scope.templateResultsPage = _.map(page, function (r) {
        return {
          rowNum: r.rowNum,
          generatedObjects: JSON.parse(r.generatedObjects)
        };
      });
    };
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
  }]).controller('TemplateResultsRowCtrl', ['$scope', function ($scope) {
    $scope.selectedFilter = 'all';
    $scope.filterObjects = function (o, type) {
      $scope.selectedFilter = type;
      if (type === 'all') {
        $scope.filteredObjects = o;
      } else {
        if (o[type]) {
          $scope.filteredObjects = o[type];
        } else {
          $scope.filteredObjects = [];
        }
      }
    };
  }]).controller('ImportTemplatesListCtrl', ['$http', '$scope', 'Api', 'ConfirmModal', 'CsvTemplatesSvc', function ($http, $scope, Api, ConfirmModal, CsvTemplatesSvc) {
    $scope.section = "csv";
    $scope.templates = [];
    CsvTemplatesSvc.get().then(function (templates) {
      $scope.templates = templates;
    });
    $scope.delete = function (template) {
      ConfirmModal.open($scope, {
        title: "Delete template",
        body: "Are you sure you want to delete template named " + template.name + " ?",
        confirmBtn: "Yes delete " + template.name,
        confirm: function confirm() {
          $http.delete(Api.url('import-template/' + template.id));
          var ti = $scope.templates.indexOf(template);
          $scope.templates.splice(ti, 1);
        }
      });
    };
  }]).controller('ImportTemplateEditCtrl', ['$http', '$location', '$routeParams', '$scope', '$timeout', 'Api', 'ConfirmModal', 'CsvTemplatesSvc', 'HandlebarsHelpersSvc', 'Logger', 'xsrf', '$uibModal', function ($http, $location, $routeParams, $scope, $timeout, Api, ConfirmModal, CsvTemplatesSvc, HandlebarsHelpersSvc, Logger, xsrf, $uibModal) {
    $scope.section = "csv";
    $scope.template = {};
    $scope.headerRow = true;
    CsvTemplatesSvc.get().then(function (templates) {
      $scope.templates = templates;
    });

    //accordion steps open and disabled controlled here
    $scope.steps = {
      1: {
        enabled: true,
        open: true
      },
      2: {
        enabled: false,
        open: false
      },
      3: {
        enabled: false,
        open: false
      },
      4: {
        enabled: false,
        open: false
      }
    };
    var openAllSteps = function openAllSteps() {
      _.each($scope.steps, function (s) {
        s.enabled = false;
        s.open = true;
      });
    };
    var createDropzone = function createDropzone() {
      // only create it once
      if ($scope.sourceFileDropzone) {
        return;
      }
      $scope.sourceFileDropzone = new Dropzone("#template-import-source-file-dropzone", {
        url: Api.url('import-template/source-file?headerRow=' + $scope.template.headerRow),
        method: "post",
        enctype: "multipart/form-data",
        headers: xsrf.getHeaders(),
        acceptedFiles: '.txt,.csv',
        dictInvalidFileType: "Files of this type are not accepted. Please select a csv file.",
        error: function error(file, e) {
          $scope.$safeApply(function () {
            $scope.dropzoneErrorMessage = "Import failed: " + (e.message || e);
          });
          $scope.sourceFileDropzone.removeFile(file);
        },
        success: function success(file, r) {
          $scope.$safeApply(function () {
            $scope.sourceFile = file;
            $scope.template.columns = r.headerRow;
            $scope.sourceFileMetadata = r.sourceFile;
          });
        },
        uploadprogress: function uploadprogress(file, progress) {
          $(file.previewElement).find('.dz-upload')[0].style.width = progress + '%';
          if (progress === 100) {
            $(file.previewElement).find('.dz-progress').remove();
            $(file.previewElement).find('.dz-size').append('<img src="img/loading/loading.gif" alt="Processing"><p>Processing...</p>');
          }
        },
        maxFiles: 1,
        maxFilesize: 2048 // MB
      });
      $scope.sourceFileDropzone.on("addedfile", function () {
        $scope.sourceFileDropzone.options.url = Api.url('import-template/source-file?headerRow=' + $scope.template.headerRow);
        $scope.$safeApply(function () {
          $scope.dropzoneErrorMessage = null;
        });
      });
      $scope.sourceFileDropzone.on("sending", function (file, xhr, formData) {
        formData.append("filesize", file.size);
      });
    };
    $scope.editorLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/handlebars");
      var mode = angular.copy(session.$modes['ace/mode/json']);
      mode.HighlightRules = session.$modes['ace/mode/handlebars'].HighlightRules;
      session.setMode(mode);
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };

    //register custom helpers
    HandlebarsHelpersSvc.get().then(function (helpers) {
      _.each(helpers, function (helper) {
        Handlebars.registerHelper(helper, function () {});
      });
    });

    /**
     * @param error string
     * @returns {{msg: string, row: number}}
     */
    function getDetailsFromHandlebarsCompileError(error) {
      // Handlebars compilation error
      var msg = error.message;
      var endOfTitle = msg.indexOf(':');
      var startOfLineNumber = msg.substring(0, endOfTitle).lastIndexOf(' ');
      var row = Number(msg.substring(startOfLineNumber + 1, endOfTitle));
      return {
        msg: msg,
        row: row
      };
    }
    function attemptHandlebarsCompile() {
      $scope.templateSizeLimit = 16777215; // The csv import file-limit based on MEDIUMTEXT in MySQL; in bytes
      $scope.estimatedTemplateSize = $scope.editor.getValue().length;
      var templateCouldFreezeUI = $scope.estimatedTemplateSize > $scope.templateSizeLimit;
      if (templateCouldFreezeUI) {
        return;
      }
      Handlebars.compile($scope.editor.getValue())();
      $scope.editor.getSession().setAnnotations([]);
    }
    $scope.editorChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      try {
        attemptHandlebarsCompile();
      } catch (error) {
        var maxRows = $scope.editor.getValue().split('\n').length;
        var _getDetailsFromHandle = getDetailsFromHandlebarsCompileError(error),
          row = _getDetailsFromHandle.row,
          msg = _getDetailsFromHandle.msg;

        // Make sure the error is actually referencing a line in the editor
        if (row > maxRows) {
          row = 1;
        }
        $scope.editor.getSession().setAnnotations([{
          row: row - 1,
          column: 0,
          text: msg,
          type: "error"
        }]);
      }
    }), 1000);
    $scope.dataSourceActivityId = function dataSourceActivityId() {
      var dataSourceStr;
      if ($scope.template.name) {
        var version = $scope.template.templateVersion;
        if (!_.isFinite(version) || version < 1) {
          version = 1;
        }
        dataSourceStr = $scope.template.name.trim() + "/" + version.toString();

        // custom slugify that retains "/" chars in activity id
        dataSourceStr = dataSourceStr.trim().toLowerCase().replace(/\s+/g, "-") // replace spaces with hyphen
        .replace(/[^\w\-\/]+/g, "") // remove non-word, non-hyphen, non-slash
        .replace(/\-\-+/g, "-") // combine multiple hyphens
        .replace(/^-+/, "") // remove hyphens at start
        .replace(/-+$/, ""); // remove hyphens at end

        // todo: get activity_id_base from import API?
        return "https://watershedlrs.com/csv-import/" + dataSourceStr;
      }
      return "";
    };

    // validate template name & version
    var validateStep1 = function validateStep1(isUpdate) {
      if (!$scope.template.name) {
        return "Import Template must have a name!";
      } else if (!$scope.template.templateVersion || $scope.template.templateVersion < 0) {
        return "Import Template must have a valid version number!";
      } else if (!isUpdate && _.find($scope.templates, function (t) {
        return t.name === $scope.template.name && t.templateVersion === $scope.template.templateVersion;
      })) {
        return "Import Template name and version must not be the same as an existing template!";
      } else {
        return null;
      }
    };

    //called on next btn click to progress the user through the steps
    $scope.step = function (i) {
      if (i === 2) {
        $scope.templateNameError = validateStep1(false);
        if ($scope.templateNameError) {
          return;
        }
        createDropzone();
      }
      $scope.steps[i].enabled = true;
      $scope.steps[i].open = true;
    };
    $scope.saveInProgress = false;
    $scope.save = function (isUpdate) {
      $scope.templateSaveError = validateStep1(isUpdate);
      if ($scope.templateSaveError) {
        return;
      }
      $scope.saveInProgress = true;
      var fd = new FormData();
      fd.append('template', new Blob([JSON.stringify($scope.template)], {
        type: 'application/json'
      }));
      fd.append('file', new Blob([$scope.template.template]));
      var url = Api.url('import-template' + (isUpdate ? '/' + $scope.template.id : ''));
      (isUpdate ? $http.put : $http.post)(url, fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      }).then(function () {
        CsvTemplatesSvc.update();
        $location.path("/data/csv/templates");
      }, function (e) {
        $scope.error = e;
        $scope.saveInProgress = false;
        Logger.warn(e);
      });
    };
    $scope.cancel = function () {
      if ($scope.template.name) {
        ConfirmModal.open($scope, {
          title: "Cancel",
          body: "Are you sure you want to cancel editing the template '" + $scope.template.name + "' ?",
          confirmBtn: "Yes",
          cancelBtn: 'No',
          confirm: function confirm() {
            $location.path("/data/csv/templates");
          }
        });
      } else {
        $location.path("/data/csv/templates");
      }
    };
    $scope.sourceFile = null;
    $scope.removeSourceFile = function () {
      if ($scope.sourceFileDropzone) {
        $scope.sourceFileDropzone.removeAllFiles();
      } else {
        createDropzone();
      }
      $scope.sourceFile = null;
      $scope.template.columns = null;
    };
    $scope.addVariable = function () {
      $scope.template.mapping[""] = "";
    };
    $scope.deleteVariable = function (k) {
      delete $scope.template.mapping[k];
    };
    $scope.mappingKeyChanged = function (newKey, oldKey) {
      var val = $scope.template.mapping[oldKey];
      delete $scope.template.mapping[oldKey];
      $scope.template.mapping[newKey] = val;
    };
    $scope.mappingValueChanged = function (newValue, key) {
      $scope.template.mapping[key] = newValue.replace(/[\s!"#%&'\(\)\*\+,\.\/;<=>@\[\\\]\^`\{\|}~]+/g, '');
    };
    $scope.previewTemplate = function previewTemplate() {
      if (!$scope.sourceFile) {
        return;
      }
      $scope.previewLoading = true;
      var fd = new FormData();
      fd.append('template', new Blob([JSON.stringify($scope.template)], {
        type: 'application/json'
      }));
      fd.append('templateFile', new Blob([$scope.template.template]));
      fd.append('sourceFileMetadata', new Blob([JSON.stringify($scope.sourceFileMetadata)], {
        type: 'application/json'
      }));
      var url = Api.url('import-template/preview');
      $http.post(url, fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      }).then(function (r) {
        $scope.error = null;
        $scope.previewStatements = _.flatten(_.values(r.data.formattedStatements));
        $scope.previewRaw = _.map(r.data.templateResultByRow, function (v, k) {
          return {
            rowNum: k,
            generatedObjects: v
          };
        });
        $scope.failedRows = _.map(r.data.failedRows, function (v, k) {
          return {
            row: k,
            detail: v
          };
        });
        $scope.rowWarnings = _.map(r.data.rowWarnings, function (v, k) {
          return {
            row: k,
            detail: v
          };
        });
        $scope.previewLoading = false;
        $scope.showRawTemplateResults();
      }, function (e) {
        $scope.error = e;
        Logger.warn(e);
        $scope.previewLoading = false;
      });
    };
    $scope.previewLoading = false;
    $scope.previewStatements = [];
    $scope.failedRows = [];
    $scope.rowWarnings = [];
    $scope.showRawTemplateResults = function () {
      $scope.rawTemplateResultsModal = $uibModal.open({
        templateUrl: 'modules/app/data/csv/template-results-modal.html',
        controller: 'TemplateResultsModalCtrl',
        backdrop: 'static',
        scope: $scope,
        size: 'lg'
      });
    };
    $scope.previewStatementsPage = [];
    $scope.pageFailedRows = [];
    $scope.pageRowWarnings = [];
    $scope.failedRowsDisplay = function (page) {
      $scope.pageFailedRows = page;
    };
    $scope.rowWarningsDisplay = function (page) {
      $scope.pageRowWarnings = page;
    };
    $scope.previewStatementsDisplay = function (page) {
      $scope.previewStatementsPage = [];
      $timeout(function () {
        $scope.previewStatementsPage = page;
      });
    };
    var createDefaultTemplate = function createDefaultTemplate(r) {
      $scope.headerRow = true;
      $scope.template = $scope.template || {};
      $scope.template = _.extend($scope.template, {
        templateVersion: 1,
        mapping: {},
        headerRow: 1
      });
      // simple default template to get the user started
      $scope.template.template = '{{!-- This is a sample template. --}}\n' + JSON.stringify({
        statements: [{
          "actor": {
            "name": r && r.headerRow ? "{{columns.[" + r.headerRow[0] + "]}}" : "Test Person",
            "mbox": "mailto:test.person@example.com"
          },
          "verb": {
            "id": "http://adlnet.gov/expapi/verbs/experienced"
          },
          "object": {
            "id": "http://watershedlrs.com/app/index.html#/data/csv/import",
            "objectType": "Activity"
          }
        }],
        groups: [],
        people: [],
        permissions: []
      }, null, 4);
      $scope.template.previousTemplate = '{}';
    };
    $scope.viewingCurrentTemplate = true;
    var originalTemplate = {};
    $scope.switchTemplates = function () {
      if ($scope.viewingCurrentTemplate) {
        originalTemplate = JSON.parse(JSON.stringify($scope.template.template));
        $scope.template.template = JSON.parse(JSON.stringify($scope.template.previousTemplate));
      } else {
        $scope.template.template = JSON.parse(JSON.stringify(originalTemplate));
      }
      $scope.viewingCurrentTemplate = !$scope.viewingCurrentTemplate;
    };

    // delay initial state logic until template is rendered (for dropzone creation)
    $timeout(function () {
      var templateId = $routeParams.templateId;
      if (templateId !== "new" && _.isFinite(templateId)) {
        $scope.template.id = templateId;
        $http.get(Api.url('import-template/' + templateId)).then(function (r) {
          $scope.template = r.data;
          $scope.template.template = r.data.contents;
          $scope.template.previousTemplate = r.data.previousContents;
        });
        openAllSteps();
        createDropzone();
      } else {
        var copyTemplateId = $routeParams.copy;
        if (copyTemplateId) {
          $http.get(Api.url('import-template/' + copyTemplateId)).then(function (r) {
            $scope.template = r.data;
            $scope.template.template = r.data.contents;
            $scope.template.previousTemplate = r.data.previousContents;
            delete $scope.template.id;
            $scope.template.name = "Copy of " + $scope.template.name;
          });
          openAllSteps();
          createDropzone();
        } else {
          createDefaultTemplate($scope.template);
        }
        originalTemplate = $scope.template.template;
      }
    });

    // Don't ever let a 0 (or any falsy value for that matter) be used for headerRow
    $scope.$watch('template.headerRow', function (newVal) {
      if (!newVal) {
        $scope.template.headerRow = 1;
      }
    });
  }]);
})();
